import { ROLES } from './roles';

export const STATUSES = {
  // Role-based status mappings
  ROLE_STATUSES: {
    [ROLES.core_Validator]: {
      ACTIVE: 'core-active',
      APPROVED: 'core-approved',
      REJECTED: 'core-rejected',
      IS_CORE_VALIDATOR: true
    },
    [ROLES.technical_validator]: {
      ACTIVE: 'technical-active',
      APPROVED: 'technical-approved',
      REJECTED: 'technical-rejected'
    },
    [ROLES.business_validator]: {
      ACTIVE: 'business-active',
      APPROVED: 'business-approved',
      REJECTED: 'business-rejected'
    },
    [ROLES.pricing]: {
      ACTIVE: 'pricing-active',
      APPROVED: 'pricing-approved',
      REJECTED: 'pricing-rejected'
    },
    [ROLES.RA]: {
      ACTIVE: 'ra-active',
      APPROVED: 'ra-approved',
      REJECTED: 'ra-rejected'
    },
    [ROLES.RA]: {
      ACTIVE: 'ra-active',
      APPROVED: 'ra-approved',
      REJECTED: 'ra-rejected'
    },
    [ROLES.committee]: {
      ACTIVE: 'active-committee',
      COMMITTEE_REVIEWED: 'committee-reviewed',
    },
  },
  COMMITTEE_REVIEW: 'committee-review',
};